import * as React from "react";

const SvgAlertTriangle = (props) => (
  <svg
    className="alert-triangle_svg__bi alert-triangle_svg__bi-alert-triangle"
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M9.938 4.016a.146.146 0 0 0-.054.057L3.027 15.74a.176.176 0 0 0-.002.183c.016.03.037.05.054.06.015.01.034.017.066.017h13.713a.12.12 0 0 0 .066-.017.163.163 0 0 0 .055-.06.176.176 0 0 0-.003-.183L10.12 4.073a.146.146 0 0 0-.054-.057.13.13 0 0 0-.063-.016.13.13 0 0 0-.064.016zm1.043-.45a1.13 1.13 0 0 0-1.96 0L2.166 15.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L10.982 3.566z"
      clipRule="evenodd"
    />
    <rect width={2} height={2} x={9.002} y={13} rx={1} />
    <path d="M9.1 7.995a.905.905 0 1 1 1.8 0l-.35 3.507a.553.553 0 0 1-1.1 0L9.1 7.995z" />
  </svg>
);

export default SvgAlertTriangle;
